import { Link } from 'react-router-dom';
import { shopByPopularCategories } from './PopularCategories';

export const Electronics = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 mb-2">
      {/* Left Column - Main Electronics Card (spans 2 rows) */}
      <div
        className={`${shopByPopularCategories[0].color} lg:row-span-2 rounded-xl p-8 flex flex-col items-center justify-center`}
      >
        <img
          src={shopByPopularCategories[0].image}
          alt={shopByPopularCategories[0].title}
          className="w-full max-w-[400px] mb-6"
          loading="lazy"
        />
        <p className="text-sm text-[#222224] mb-2 text-center">
          {shopByPopularCategories[0].desc}
        </p>
        <h4 className="text-2xl font-bold mb-4">
          {shopByPopularCategories[0].title}
        </h4>
        <Link
          to={shopByPopularCategories[0].link}
          className="bg-[#FFDE11] px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#e6c800] transition-colors"
        >
          SHOP NOW
        </Link>
      </div>

      {/* Right Top - Smart TVs */}
      <Link
        to="/electronics/tv"
        className="bg-[#F5F5F7] hover:bg-gray-200 rounded-xl flex flex-col items-center justify-center transition-colors"
      >
        <div className="w-full md:px-24 px-20 py-6 md:py-10 rounded-xl flex flex-col items-center justify-center">
          <img
            src="/images/television.min.svg"
            alt="Smart TVs"
            className="w-full  mb-4"
            loading="lazy"
          />
          <p className="text-sm font-medium">Smart TVs</p>
        </div>
      </Link>

      {/* Right Bottom - Split into 2 columns */}
      <div className="grid grid-cols-2 gap-2">
        {/* Laptops */}
        <Link
          to="/electronics/computers"
          className="bg-[#F5F5F7] rounded-xl p-6 flex flex-col items-center justify-center hover:bg-gray-200 transition-colors"
        >
          <img
            src="/images/macbook.min.svg"
            alt="Laptops"
            className="w-full max-w-[150px] mb-3"
            loading="lazy"
          />
          <p className="text-sm font-medium">Laptops</p>
        </Link>

        {/* Cell phones */}
        <Link
          to="/electronics/phones"
          className="bg-[#F5F5F7] rounded-xl p-6 flex flex-col items-center justify-center hover:bg-gray-200 transition-colors"
        >
          <img
            src="/images/mobile-phone.min.svg"
            alt="Cell phones"
            className="w-full max-w-[100px] mb-3"
            loading="lazy"
          />
          <p className="text-sm font-medium">Cell phones</p>
        </Link>
      </div>
    </div>
  );
};
